import { IconNames } from "../../Foundation/Icons";

export enum BadgeTypes {
    Live = "Live",
    Generic = "Generic",
    Topic = "Topic",
    NeutralDark = "NeutralDark",
}

export type BadgeProps = {
    type: BadgeTypes;
    text: string;
    icon?: IconNames;
    iconRight?: boolean;
    className?: string;
};
